// Design System 2.0 (2026-10, Phase 1) — presentational only. Health is an attention state,
// rendered as an 8px dot + 3px halo + semibold label in the tone colour — never a chip, never
// a background fill. `reason` prop exists for a later phase; not rendered anywhere yet
// (Nikhil decision: no reason text for now).
const HEALTH_TONE = {
  on_track: { dot: "bg-health-ontrack-dot", text: "text-health-ontrack-text", halo: "ring-health-ontrack-halo", label: "On Track" },
  healthy: { dot: "bg-health-ontrack-dot", text: "text-health-ontrack-text", halo: "ring-health-ontrack-halo", label: "Healthy" },
  needs_attention: { dot: "bg-health-attention-dot", text: "text-health-attention-text", halo: "ring-health-attention-halo", label: "Needs Attention" },
  waiting_on_client: { dot: "bg-health-waiting-dot", text: "text-health-waiting-text", halo: "ring-health-waiting-halo", label: "Waiting on Client" },
  at_risk: { dot: "bg-health-risk-dot", text: "text-health-risk-text", halo: "ring-health-risk-halo", label: "At Risk" },
};

export function HealthMarker({ health, label, reason, testId }) {
  const meta = HEALTH_TONE[health];
  if (!meta) return null;
  return (
    <span data-testid={testId} className="inline-flex items-center gap-2" title={reason || meta.label}>
      <span className={`h-2 w-2 rounded-full ring-[3px] shrink-0 ${meta.dot} ${meta.halo}`} />
      <span className={`text-xs font-semibold ${meta.text}`}>{label || meta.label}</span>
    </span>
  );
}

export const HEALTH_KEYS = Object.keys(HEALTH_TONE);
